export function userById(id) {
    return `/users/${id}`;
}
